<div class="page-title">
  <h1>Importar pessoas</h1>
</div>

<section class="primeiro-container">
  <div class="container-toggles">
    <button
      class="seletor-tela"
      [ngClass]="{'botao-ativo': telaExibida == 1}"
      (click)="telaExibida=1"
    >
      Importar
    </button>
    <button
      class="seletor-tela"
      [ngClass]="{'botao-ativo': telaExibida == 2}"
      (click)="telaExibida=2"
    >
      Histórico de importações
    </button>
  </div>
</section>

@if (telaExibida == 1) {
<div>
  <app-importar-pessoas></app-importar-pessoas>
</div>
} @if (telaExibida == 2) {
<div class="tela-historico">
  <app-importar-pessoas-historico></app-importar-pessoas-historico>
</div>
}
